import React from "react";
import rainbow from "../assets/images/rainbow/rainbow-main.png";

const Rainbow = () => {
  return (
    <>
      <div className="rainbow-wrapper">
        <img src={rainbow} alt="" />
      </div>
      <div className="rainbow-sparkle"></div>
    </>
  );
};

export default Rainbow;
